// extracted by mini-css-extract-plugin
export var categoryMenu = "Q0vsI";